import { render, staticRenderFns } from "./select-box.vue?vue&type=template&id=16e29d38&scoped=true"
import script from "./select-box.vue?vue&type=script&lang=js"
export * from "./select-box.vue?vue&type=script&lang=js"
import style0 from "./select-box.vue?vue&type=style&index=0&id=16e29d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e29d38",
  null
  
)

export default component.exports